import React, { Component } from 'react';

import CardWrapper from '../../../hoc/CardWrapper/CardWrapper';
import Button from '../../UI/Button/Button';
import Input from '../../UI/Input/Input';

import classes from './SignInModalForm.module.css';
import { IsObjectEmpty, GetObjectClone, AddInLocalStorage, IsStringEmpty, Error } from '../../../utilities/CommonMethods';
import FormFields from '../FormFields';
import UserAPIController from '../../../webServices/UserAPIController';
import Constants from '../../../utilities/Constants';

import closeBlack from '../../../assets/icons/icon-close-black.png';

import amplitude from 'amplitude-js';

class signInModalForm extends Component {
	state = {
		signInFormData: GetObjectClone(FormFields.signInForm),
		signInFormValid: false,
		showLoader: false,
		verificationLinkExpired: false,
	}

	checkValidity = (formElement) => {
		let isValid = true;

		if (!IsObjectEmpty(formElement.validation)) {
			let value = formElement.value;
			const rules = formElement.validation;
			if (!IsObjectEmpty(rules.required) && rules.required.value) {
				isValid = (value.length > 0) && isValid;
				formElement.errorMessage = isValid ? '' : rules.required.errorMessage;
				formElement.valid = isValid;
			}
			if (!IsObjectEmpty(rules.isPassword) && rules.isPassword.value) {
				const validPasswordFormat = Constants.REGEX_PASSWORD_VALIDITY;
				isValid = validPasswordFormat.test(value) && isValid;
				formElement.errorMessage = isValid ? '' : rules.isPassword.errorMessage;
				formElement.valid = isValid;
			}
		}
		return (formElement);
	}

	inputChangedHandler = (event, inputIdentifier) => {
		const updatedForm = { ...this.state.signInFormData };
		let updatedFormElement = { ...updatedForm[inputIdentifier] };
		updatedFormElement.value = event.target.value;
		updatedFormElement.touched = true;
		updatedFormElement = this.checkValidity(updatedFormElement, updatedForm);
		updatedForm[inputIdentifier] = updatedFormElement;
		let formIsValid = true;
		for (let inputIdentifier in updatedForm) {
			if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
				formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
			}
		}

		this.setState({ signInFormData: updatedForm, signInFormValid: formIsValid });
	}

	onEnterClicked = (e, key) => {
		if ((e.which === 13 || e.keyCode === 13) && key === 'password') {
			this.signInButtonClick();
		}
	}

	inputFieldsSignIn = (key) => {
		return <Input
			elementType={this.state.signInFormData[key].elementType}
			elementConfig={this.state.signInFormData[key].elementConfig}
			label={this.state.signInFormData[key].label}
			value={this.state.signInFormData[key].value}
			changed={(event) => this.inputChangedHandler(event, key)}
			keyDown={(event) => this.onEnterClicked(event, key)}
			touched={this.state.signInFormData[key].touched}
			required={!IsObjectEmpty(this.state.signInFormData[key].validation) ? (!IsObjectEmpty(this.state.signInFormData[key].validation.required) ? this.state.signInFormData[key].validation.required.value : false) : false}
			showError={(!this.state.signInFormValid && !this.state.signInFormData[key].valid) ? true : false}
			error={this.state.signInFormData[key].errorMessage} />
	}

	signInButtonClick = () => {
		const updatedForm = { ...this.state.signInFormData };
		for (let item in updatedForm) {
			updatedForm[item] = this.checkValidity(updatedForm[item], updatedForm);
		}

		let formIsValid = true;
		for (let inputIdentifier in updatedForm) {
			if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
				formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
			}
		}

		amplitude.getInstance().init('b5a1118f4ff077d8cc8dc50c5785e6b8');
		amplitude.getInstance().logEvent('LOGIN_FORM_BUTTON');


		this.setState({ signInFormData: updatedForm, signInFormValid: formIsValid });
		if (formIsValid) {
			this.setState({ showLoader: true });
			UserAPIController.userLogin(this.state.signInFormData.username.value, this.state.signInFormData.password.value)
				.then(response => {

					AddInLocalStorage(Constants.KEY_TOKEN, response.result.token);
					AddInLocalStorage(Constants.KEY_USER_LOGGED_IN, true);
					AddInLocalStorage(Constants.KEY_PROFILE_PIC, response.result.userDetails.profilePic);
					AddInLocalStorage(Constants.KEY_FULL_NAME, response.result.userDetails.fullName);
					AddInLocalStorage(Constants.KEY_EMAIL, response.result.userDetails.email);
					AddInLocalStorage(Constants.KEY_USERNAME, response.result.userDetails.username);
					AddInLocalStorage(Constants.KEY_USER_ID, response.result.userDetails.userId);

					this.setState({ showLoader: false });
					this.props.getCommonData(response.result.userDetails);
				})
				.catch(err => {
					console.log('Error Login => ', err);
					this.setState({ showLoader: false });
					Error('SIGNINMODALFORM RESPONSE ERROR => ', err.error.message);

					if (err.error.status === 400) {
						// this.props.onUpdateLoading(false);
						if (!IsObjectEmpty(err.error.errorList)) {
							Error('SIGNINMODALFORM RESPONSE ERRORLIST => ', err.error.errorList);
							const updatedForm = { ...this.state.signInFormData };
							const errorList = { ...err.error.errorList };
							let verificationLinkExpiredStatus = false;
							for (let item in errorList) {
								if (!IsStringEmpty(errorList[item])) {
									// // console.log('Iteratig Form => ', item, updatedForm[item], errorList[item]);
									if (item === 'password' && errorList[item] === 'Email verification pending. Please verify the email address to log in.') {
										verificationLinkExpiredStatus = true;
									}
									updatedForm[item].errorMessage = errorList[item];
									updatedForm[item].valid = !IsObjectEmpty(updatedForm[item]) ? false : true;
								}
							}

							let formIsValid = true;
							for (let inputIdentifier in updatedForm) {
								if (!IsObjectEmpty(updatedForm[inputIdentifier].validation.required) && updatedForm[inputIdentifier].validation.required.value) {
									formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
								}
							}

							this.setState({ signInFormData: updatedForm, signInFormValid: formIsValid, showLoader: false, verificationLinkExpired: verificationLinkExpiredStatus });
						} else {
							Error('SIGNINMODALFORM RESPONSE ERROR => ', err.error.message);
							this.setState({ showLoader: false });
							this.props.onFailureDialogShow(err.error.message, 'OKAY');
						}
					}
					if (err.error.status === 401) {
						if (err.error.message === 'Invalid token.') {
							this.props.showSessionExpiredDialog(true);
						} else {
							this.props.redirectToUnauthorized();
						}
					}
					if (err.error.status === 404) {
						this.props.redirectToNotFound();
					}
					if (err.error.status === 500) {
						this.props.redirectToServerError();
					}
				});
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.showLineLoader !== this.props.showLineLoader) {
			this.setState({ showLoader: this.props.showLineLoader });
		}
	}

	componentWillUnmount() {
		this.setState({ signInFormData: GetObjectClone(FormFields.signInForm), signInFormValid: false })
	}

	render() {
		return (
			<CardWrapper isLoading={this.state.showLoader} noShadow={this.props.hideCloseButton ? false : true}>
				<div className={classes.Heading}>
					<p className={this.props.forLoginPage === true ? classes.AddMarginTop : null}>Log In</p>
					{
						this.props.hideCloseButton || this.props.forLoginPage === true ? null :
							<div className={classes.IconButtonDiv}>
								<img
									className={classes.CloseButton}
									src={closeBlack}
									alt='Close Sign In Modal'
									onClick={this.props.closeButtonClick}
								/>
							</div>
					}
				</div>

				<form autoComplete="off">
					<div className={classes.Form}>
						<input autoComplete="false" name="hidden" type="text" style={{ display: "none" }} />
						<div className={classes.Username}>{this.inputFieldsSignIn('username')}</div>
						<div className={classes.Password}>{this.inputFieldsSignIn('password')}</div>
					</div>
				</form>
				<div className={classes.ButtonContainer}>
					<Button
						label="LOG IN"
						buttonId="Popup-SignIn-Button"
						styleclass="RoundCorners NonMobileOnly"
						clicked={this.signInButtonClick}
						disabled={false}
						tooltip={null}
						margin="16px 0px 20px 0px"
					/>
					<Button
						label="LOG IN"
						buttonId="Popup-SignIn-Button"
						styleclass="RoundCorners MobileOnly"
						clicked={this.signInButtonClick}
						disabled={false}
						tooltip={null}
						fontSize="0.625em"
						margin="16px 0px 0px 0px"
					/>
				</div>

				<div className={classes.Footer}>

					<p className={classes.DontHaveAccountText}>Forgot your password ?
						<Button
							label="RESET PASSWORD"
							fontSize="15px"
							fontWeight="500"
							styleclass="TextOnlyButtonBlue"
							disabled={false}
							tooltip={null}
							margin="0px 0px 0px 0.5em"
							padding="0px 0px 0px 0px"
							clicked={this.props.onResetPasswordLinkClick}
						/>
					</p>
				</div>
			</CardWrapper>
		);
	}
}




export default signInModalForm;